/* eslint-disable */

import React, { FunctionComponent, useState } from 'react';
import dayjs, { Dayjs } from 'utilities/dayjs';
import { EventModel } from 'features/events/EventModel';
import { Broadcast } from 'features/broadcast/broadcastsSlice';
import { startTimeChecker } from 'utilities/startTimeChecker';
import useInterval from 'hooks/useInterval';
import humanizeDuration from 'humanize-duration';
import { pad, formatDurationClock } from 'utilities/formatters';

interface EventTimerProps {
  event: EventModel;
  broadcast: Broadcast;
}

// Elapsed milliseconds since the broadcast started.
const calculateCurrentPlayingTime = (startedAt: Dayjs | null): number => {
  if (!startedAt) {
    return 0;
  }

  return dayjs().diff(startedAt);
};

export const EventTimer: FunctionComponent<EventTimerProps> = ({
  event,
  broadcast
}) => {
  const startedAt = startTimeChecker(event, broadcast);
  const [currentPlayingTime, setCurrentPlayingTime] = useState<number>(
    calculateCurrentPlayingTime(startedAt)
  );

  useInterval(() => {
    setCurrentPlayingTime(calculateCurrentPlayingTime(startedAt));
  }, 1000);

  const formatTime = (currentPlayingTimeMs: number): string => {
    if (currentPlayingTimeMs / 3600000 > 24) {
      const hours = Math.trunc(currentPlayingTimeMs / 3600000) % 24;
      const mins = Math.trunc(currentPlayingTimeMs / 60000) % 60;
      const secs = Math.trunc(currentPlayingTimeMs / 1000) % 60;
      const humanizedDuration = humanizeDuration(currentPlayingTimeMs, {
        units: ['y', 'd'],
        round: true
      });
      return `+ ${humanizedDuration}, ${pad(hours, 2)}:${pad(mins, 2)}:${pad(
        secs,
        2
      )}`;
    }

    return formatDurationClock(currentPlayingTimeMs);
  };

  return <span className="tnum">{formatTime(currentPlayingTime)}</span>;
};
